import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { Box, DialogContent, DialogTitle, Grid, TextField } from '@mui/material';

import { DialogFooter, DialogActionButton } from 'components/Dialog';

import { useStyles } from './styles';
import { compose } from 'utils/compose';
import { EDIT_NOTICE } from '../../constants/verbiage';
import withMediaQuery from '../../constants/mediaQuery';

// HOC to inject styles into class component
// no-dd-sa:javascript-code-style/parameter-name
const withUseStyles = (WrappedComponent) => {
  return function WithStylesWrapper(props) {
    const classes = useStyles();
    return <WrappedComponent {...props} classes={classes} />;
  };
};

class EditInstructionDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      instruction: '',
      access_code: '',
    };
  }

  componentDidMount() {
    const { delivery, editedDeliveryData } = this.props.store.deliveryStore;
    const { shipment } = delivery;

    this.setState({
      instruction: editedDeliveryData.delivery_instruction || shipment.dropoff_additional_instruction,
      access_code: editedDeliveryData.access_code || shipment.dropoff_access_code,
    });
  }

  handleInputChange = (field, value) => {
    this.setState({ [field]: value });
  };

  save = () => {
    const { deliveryStore } = this.props.store;
    const { instruction, access_code } = this.state;

    deliveryStore.setEditedDeliveryField('delivery_instruction', instruction);
    deliveryStore.setEditedDeliveryField('access_code', access_code);
    deliveryStore.saveAndCloseDialog();
  };

  render() {
    const { classes, store, mediaQuery } = this.props;
    const { deliveryStore } = store;
    const { delivery, tokenRemainingTimeString } = deliveryStore;

    if (!delivery) return null;

    const { shipment } = delivery;

    return (
      <Box sx={classes.container}>
        <DialogTitle sx={classes.titleBox}>
          <Grid
            container
            justifyContent="space-between"
            alignItems={mediaQuery.isMobile ? 'flex-start' : 'center'}
            direction={mediaQuery.isMobile ? 'column' : 'row'}
            spacing={mediaQuery.isMobile ? 1 : 0}
          >
            <Grid sx={classes.dialogTitle}>
              <span style={{ fontWeight: 600 }}>Edit Delivery Instructions</span>
            </Grid>
            <Grid sx={classes.dialogTimer}>
              <Box component="span" sx={classes.underlined}>
                Session time:
              </Box>
              <Box component="span" sx={classes.timerCounter}>
                {tokenRemainingTimeString}
              </Box>
            </Grid>
          </Grid>
          <Box pt={2} pb={mediaQuery.isMobile ? 2 : 3} sx={classes.noticeBox}>
            <span style={{ fontWeight: 600 }}>{EDIT_NOTICE}</span>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box mb={3}>
            <Box pb={2} pt={1}>
              <span style={{ fontWeight: 600 }}>Delivery Instructions:</span>
            </Box>
            <TextField
              placeholder="Tell us more about where should we leave the package or tips to find your address!"
              fullWidth
              multiline
              rows={5}
              variant="outlined"
              defaultValue={deliveryStore.getEditedDeliveryField('delivery_instruction') || shipment.dropoff_additional_instruction}
              onChange={(e) => this.handleInputChange('instruction', e.target.value)}
              slotProps={{
                htmlInput: { style: classes.inputField },
              }}
            />
          </Box>
          <Box mb={3}>
            <Box py={2}>
              <span style={{ fontWeight: 600 }}>Access code:</span>
            </Box>
            <TextField
              placeholder="e.g: #1234"
              fullWidth
              variant="outlined"
              defaultValue={deliveryStore.getEditedDeliveryField('access_code') || shipment.dropoff_access_code}
              onChange={(e) => this.handleInputChange('access_code', e.target.value)}
              slotProps={{
                htmlInput: { style: classes.inputField },
              }}
            />
          </Box>
        </DialogContent>
        <DialogFooter sx={classes.dialogActionsWrapper}>
          <DialogActionButton onClick={() => deliveryStore.closeEditDialog()} color="primary" variant="outlined" disableElevation>
            Cancel
          </DialogActionButton>
          <DialogActionButton onClick={this.save} variant="contained" color="primary" disableElevation>
            Save
          </DialogActionButton>
        </DialogFooter>
      </Box>
    );
  }
}

const EditInstructionDialogCompose = compose(inject('store'), observer)(EditInstructionDialog);

export default withUseStyles(withMediaQuery()(EditInstructionDialogCompose));
